/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import {Trans} from "react-i18next";

class Member extends Component {
  rowClassName = "";

  state = {
    showingTabletDetail: false,
  };

  toggleTabletDetail = () => {
    let showing = this.state.showingTabletDetail;
    this.setState({ showingTabletDetail: !showing });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };
  renderTabletModeDetail = (t) => {
    if (!this.state.showingTabletDetail) return null;

    return (
      <tr className="child">
        <td className="child" colspan="2">
          <table>
            <tr data-dt-row="0" data-dt-column="2">
              <td>
                <div className="tableTitle"><Trans desc="Pozisyon">10064</Trans></div>
              </td>
              <td>{t.position?.name}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="5">
              <td>
                <div className="tableTitle"><Trans desc="Mevcut Yeterlilik">10065</Trans></div>
              </td>
              <td>{t.qualifications}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="3">
              <td>
                <div className="tableTitle"><Trans desc="Gelecek Yeterlilik">10066</Trans></div>
              </td>
              <td>{t.futureQualifications}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="3">
              <td>
                <div className="tableTitle"><Trans desc="E-öğrenme Tamamlama Oranı">10557</Trans></div>
              </td>
              <td>{t.eLearningCompletionRate}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="6">
              <td>
                <div className="tableTitle"><Trans desc="İşe Giriş Tarihi">10067</Trans></div>
              </td>
              <td>{this.renderDate(t.workJoin)}</td>
            </tr>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { mem } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <tr className={this.rowClassName}>
            <td className="showGrup">{mem.fullname}</td>
            <td className="showGrup">
              {mem.position ? mem.position.name : "-"}
            </td>
            <td className="showGrup">{mem.qualifications}</td>
            <td className="showGrup">{mem.futureQualifications}</td>
            <td className="showGrup">{mem.eLearningCompletionRate}</td>
            <td className="showGrup">{this.renderDate(mem.workJoin)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.toggleTabletDetail}>
            <td className="showGrup">{mem.fullname}</td>
          </tr>
          {this.renderTabletModeDetail(mem)}
        </TabletBreakpoint>
      </>
    );
  }
}

export default Member;
